import * as LoadingOverlayActions from "./action";
import { reducer, State as LoadingOverlayState } from "./reducer";

export { LoadingOverlayActions };
export type { LoadingOverlayState };
export default reducer;
